import { Box, Grid, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import SvgCard from "../../components/SvgCard";
import { BlueSection, SectionTitle } from "../../styles/HomeStyles";
import { motion } from "framer-motion";

const Africa = () => {
  return (
    <BlueSection>
      <Container sx={{ marginY: 2 }}>
        <Grid container spacing={4} justifyContent="center" alignItems="center">
          <Grid item xs={10} sm={6} md={4}>
            <SectionTitle sx={{ textAlign: "center", mb: 2 }}>
              Pays
            </SectionTitle>
            <motion.div
              initial={{ scale: 0.1, opacity: 0 }}
              //  animate={{ scale: 1, opacity: 1 }}
              whileInView={{ scale: 1, opacity: 1 }}
              viewport={{ amount: 0.5, once: true }}
              // whileHover={{ scale: 1.1 }}
              transition={{
                type: "spring",
                stiffness: 90,
                //  delay: 1,
              }}
              sx={{ mat: 5 }}
            >
              <motion.img src="./static/svg/Logo/africa.svg" alt="africa" />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </BlueSection>
  );
};

export default Africa;
